/**
 * @generated SignedSource<<495350ced155a9fd1dec57581434d7d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type homeAroundMorningStudioSecondaryContentItemContent$data = {
  readonly entityId: string;
  readonly topics: ReadonlyArray<{
    readonly sponsor: {
      readonly name: string | null;
      readonly type: string | null;
    } | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "homeAroundMorningStudioSecondaryContentItemContent";
};
export type homeAroundMorningStudioSecondaryContentItemContent$key = {
  readonly " $data"?: homeAroundMorningStudioSecondaryContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"homeAroundMorningStudioSecondaryContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "homeAroundMorningStudioSecondaryContentItemContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Sponsor",
          "kind": "LinkedField",
          "name": "sponsor",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "045b1c46595cc3d82fecff9bc9820b0c";

export default node;
